import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

async function errorMessageFromResponse(response, fallback) {
  try {
    const data = await response.json();
    if (data && typeof data.message === 'string') return data.message;
  } catch {
    /* ignore */
  }
  return fallback;
}

function OfficesList() {
  const [offices, setOffices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { authFetch } = useAuth();

  const quotaCell = (value, { negativeClassName } = {}) => {
    if (typeof value !== 'number' || Number.isNaN(value)) return <span className="text-muted">—</span>;
    const className = value < 0 && negativeClassName ? negativeClassName : undefined;
    return <span className={className}>{value}</span>;
  };

  useEffect(() => {
    const fetchOffices = async () => {
      try {
        const response = await authFetch('/api/v1/offices');
        if (response.ok) {
          const data = await response.json();
          setOffices(Array.isArray(data) ? data : []);
        } else if (response.status === 403) {
          setError(await errorMessageFromResponse(response, 'Нет доступа к списку офисов.'));
        } else {
          setError(await errorMessageFromResponse(response, 'Не удалось загрузить список офисов.'));
        }
      } catch (e) {
        setError('Ошибка при загрузке офисов: ' + e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOffices();
  }, [authFetch]);

  if (loading) {
    return (
      <div className="container mt-4">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Загрузка...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Офисы</h2>
      <div className="card">
        <div className="card-body">
          {offices.length === 0 ? (
            <p className="text-muted mb-0">Нет офисов для отображения.</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped mb-0">
                <thead>
                  <tr>
                    <th>Название</th>
                    <th style={{ width: '140px' }}>Использовано</th>
                    <th style={{ width: '140px' }}>Осталось</th>
                    <th style={{ width: '140px' }}>Действия</th>
                  </tr>
                </thead>
                <tbody>
                  {offices.map((office) => (
                    <tr key={office.id}>
                      <td>{office.name}</td>
                      <td>{quotaCell(office.quota_used)}</td>
                      <td>{quotaCell(office.quota_remaining, { negativeClassName: 'text-danger fw-semibold' })}</td>
                      <td>
                        <Link className="btn btn-sm btn-outline-primary" to={`/offices/${office.id}`}>
                          Открыть
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default OfficesList;
